import React from "react";
import {
  DateInput,
  formatDate,
  formatDateTime,
  formatFull,
  formatRelative,
  toDate,
} from "../dates";

export type DateTextProps = {
  /** A Date, or unix seconds. */
  value: DateInput;
  /** "date" (4 Nov), "datetime" (4 Nov, 11:43) or "relative" (Today 11:43). */
  format?: "date" | "datetime" | "relative";
} & Omit<React.ComponentPropsWithoutRef<"time">, "dateTime" | "children">;

const formatters = {
  date: formatDate,
  datetime: formatDateTime,
  relative: formatRelative,
};

/** A date written the product's way, with the full date on hover. */
export function DateText({ value, format = "date", ...rest }: DateTextProps) {
  const d = toDate(value);
  return (
    <time
      dateTime={d.toISOString()}
      title={formatFull(d, format !== "date")}
      {...rest}
    >
      {formatters[format](d)}
    </time>
  );
}
